import { Avatar, Card, Empty, Tag, Tooltip } from 'antd'
import LoeadMorePagination from 'components/elements/BaseInfinityScroll/LoeadMorePagination'
import { BlockLoader } from 'components/elements/Loader'
import { LeadTimeLineEmptyMessageIcon, SvgTextIcon } from 'components/icons'
import { useLeadDetails } from 'features/leads/providers/LeadDetailsProvider'
import { TUserActivityTxtLog } from 'features/leads/types'
import { FC, useState } from 'react'
import { formatDate } from 'utils/functions'
import useFetchPageNew from 'hooks/useFetchpageNew'
import { buildDetailModal } from './components/ActivityDetailModal'

const TextActivity: FC = () => {
 const { Meta } = Card

 const { leadId, realtorId } = useLeadDetails()
 const [detailData, setDetailData] = useState<TUserActivityTxtLog | undefined>()
 const [showModal, setShowModal] = useState<boolean>()
 const { flatData, isLoading, fetchMore, hasMore, isRefetching, total } =
  useFetchPageNew<TUserActivityTxtLog>(`lead/profile/${leadId}`, {
   body: { type: 'textlog', ...(realtorId ? { realtor_id: realtorId } : {}) },
   method: 'post',
  })

 if (isLoading) {
  return <BlockLoader />
 }

 if (!flatData || flatData.length === 0) {
  return (
   <div className="no-data-empty-compo">
    <Empty
     image={
      <span className="no-data-image">
       <LeadTimeLineEmptyMessageIcon />
      </span>
     }
     description={<span className="no-data-heading">No SMS History</span>}
    >
     <p className="no-data-description">
      No results found related to SMS history
     </p>
    </Empty>
   </div>
  )
 }

 return (
  <Card
   className="activity-layout-crd"
   title={`SMS (${total})`}
   loading={isLoading}
   bodyStyle={{ flex: 1 }}
  >
   <div className="card-body-inner">
    <LoeadMorePagination
     fethMore={fetchMore}
     hasMore={hasMore}
     loading={isRefetching}
    >
     {flatData?.map((item, index) => (
      <Card
       hoverable
       onClick={() => {
        setShowModal(true)
        setDetailData(item)
       }}
       style={{ borderColor: '#ccc' }}
       className="mb-2"
       key={index}
      >
       <div className="d-flex justify-content-between">
        <div>
         <Meta
          avatar={<Avatar size={50} icon={<SvgTextIcon />} />}
          description={
           <div>
            <h3 className="mb-0 mt-0">
             {item?.from_name} <i className="fal fa-angle-right" />{' '}
             {item?.to_name}
            </h3>
            {item?.updated_at && (
             <p className="mb-0 mt-2" style={{ fontSize: '13px' }}>
              <span
               style={{
                border: ' 1px solid #ccc',
                padding: ' 0 7px',
               }}
              >
               {formatDate?.(item?.updated_at)}
              </span>
              {item?.status && (
               <Tooltip
                overlay={item?.error_message}
                overlayStyle={{ maxWidth: '450px' }}
               >
                <Tag
                 className="ms-2"
                 color={item?.error_message ? 'red' : 'blue'}
                >
                 {item?.status}
                </Tag>
               </Tooltip>
              )}
             </p>
            )}
           </div>
          }
         />
        </div>
       </div>
      </Card>
     ))}
    </LoeadMorePagination>
   </div>
   {showModal &&
    buildDetailModal(
     () => {
      setShowModal(false)
      setDetailData(undefined)
     },
     showModal,
     'text',
     undefined,
     false,
     detailData,
    )}
  </Card>
 )
}
export default TextActivity
